export default "__VITE_ASSET__C14izJ4e__"